import type { SourceListItem } from "../../tars-hooks/useSourceList";
import type { SourceNode } from "../sidebar/sources-types";
import { isFile } from "../sidebar/sources-types";

/** `election_label` values from source list records where `type` is `data_bank`. */
export function referenceTableOptionsFromSourceList(
    sources: SourceListItem[] | undefined
): string[] {
    if (!Array.isArray(sources)) return [];
    const labels: string[] = [];
    for (const item of sources) {
        if (item.type !== "data_bank") continue;
        const more = item.more;
        if (more == null || typeof more !== "object") continue;
        const label = more.election_label;
        if (typeof label === "string" && label.trim() !== "") {
            labels.push(label.trim());
        }
    }
    return [...new Set(labels)].sort((a, b) => a.localeCompare(b));
}

export function mergeReferenceTableOptions(...optionLists: string[][]): string[] {
    return [...new Set(optionLists.flat())].sort((a, b) => a.localeCompare(b));
}

export function referenceTableOptionsFromSourceNodes(
    nodes: Record<string, SourceNode>
): string[] {
    const labels: string[] = [];
    for (const node of Object.values(nodes)) {
        if (!isFile(node) || node.type !== "dataBank") continue;
        const election = node.data_bank_election?.trim();
        if (election) labels.push(election);
    }
    return [...new Set(labels)].sort((a, b) => a.localeCompare(b));
}
